function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.83335 1.66663C7.74868 1.66663 6.83157 2.36558 6.48635 3.33329H2.16669V4.99996H6.48635C6.83157 5.96767 7.74868 6.66663 8.83335 6.66663C10.2117 6.66663 11.3334 5.54496 11.3334 4.16663C11.3334 2.78829 10.2117 1.66663 8.83335 1.66663ZM13 3.33329V4.99996H18.8334V3.33329H13ZM13 7.49996C11.9153 7.49996 10.9982 8.19892 10.653 9.16663H2.16669V10.8333H10.653C10.9982 11.801 11.9153 12.5 13 12.5C14.3784 12.5 15.5 11.3783 15.5 9.99996C15.5 8.62163 14.3784 7.49996 13 7.49996ZM17.1667 9.16663V10.8333H18.8334V9.16663H17.1667ZM6.33335 13.3333C5.24868 13.3333 4.33157 14.0322 3.98635 15H2.16669V16.6666H3.98635C4.33157 17.6343 5.24868 18.3333 6.33335 18.3333C7.71169 18.3333 8.83335 17.2116 8.83335 15.8333C8.83335 14.455 7.71169 13.3333 6.33335 13.3333ZM10.5 15V16.6666H18.8334V15H10.5Z",
  fill: "#8A93A6"
});

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.3a837986.svg";
export { ForwardRef as ReactComponent };